import { render, staticRenderFns } from "./no-services-base.vue?vue&type=template&id=06015c3c&"
import script from "./no-services-base.vue?vue&type=script&lang=js&"
export * from "./no-services-base.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports